enum CartInfo {
  SET_CART_ITEM_COUNT = 'cart/setCartItemCount',
  SET_CART_DATA = 'cart/setCartData',
}

export default CartInfo;
